<template>
  <div>
    <v-card>
      <v-card-title v-if="title"> {{ pageTitle }} </v-card-title>
      <v-card-text v-if="descriptionHtml">
        <span v-html="descriptionHtml"></span>
        <v-divider></v-divider>
      </v-card-text>
      <v-btn @click="excelExport" color="#428610" small class="ml-2 mb-3">
        <v-icon style="color: white">
          {{ icons.mdiMicrosoftExcel }}
        </v-icon>
        <span class="pl-2 white--text">{{ $t('Vie vastaukset') }}</span>
      </v-btn>
      <v-tabs v-model="tab" @change="tabChange">
        <v-tab href="#tab-1">{{ $t("Yhteenveto") }}</v-tab>
        <v-tab href="#tab-2">{{ $t("Vastaukset") }} ({{ answers.length }})</v-tab>
        <v-tab-item value="tab-1">
          <br />
          <div v-if="answers.length">
            <div v-for="q in poll.poll_questions" :key="q.id">
              <v-card-title>
                {{ q.question }}
              </v-card-title>
              <v-card-text>
                <template v-if="q.question_type == 1">
                  <div style="max-width: 90%">
                    <apex-horizontal-bar-chart :series="getChartSeries(q)" :categories="getChartLabels(q)"
                      :height="q.question_options.length * 100">
                    </apex-horizontal-bar-chart>
                  </div>
                </template>
                <template v-else>
                  <v-text-field v-for="answer in answers" :value="getTextAnswer(q, answer)" :key="answer.id" outlined
                    readonly hide-details="" class="mb-2"></v-text-field>
                </template>
              </v-card-text>
              <v-divider></v-divider>
            </div>
            <br />
          </div>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <div>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th v-if="poll.anonymous == false">
                      <h3>{{ $t("Käyttäjä") }}</h3>
                    </th>
                    <th>
                      <h3>{{ $t("Vastausaika") }}</h3>
                    </th>
                    <th v-for="question in poll.poll_questions" :key="'th-' + question.id">
                      <h3>{{ question.question }}</h3>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="answer in answers" :key="answer.id">
                    <td v-if="poll.anonymous == false">
                      {{ answer.user }}
                    </td>
                    <td>
                      {{ getInsertTime(answer) }}
                    </td>
                    <td v-for="question in poll.poll_questions"
                      :key="'question-answer-' + answer.id + '-' + question.id">
                      <template v-if="question.question_type == 1">{{
                        getOptionAnswer(question, answer)
                        }}</template>
                      <template v-else>{{
                        getTextAnswer(question, answer)
                        }}</template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <br />
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
var showdown = require("showdown");
import targetblank from "showdown-target-blank";
import barChart from "@/components/charts/horizontal_bar_chart.vue";
import adminApi from "@/api/admin";
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import ApexHorizontalBarChart from "@/components/charts/apex_horizontal_bar_chart.vue";
import useMarkdown from "@/@core/utils/useMarkdown";
import { writeFileXLSX, utils } from "xlsx";
import { mdiFileExcel, mdiMicrosoftExcel, mdiFileExcelBox, mdiFileExcelBoxOutline, mdiFileExcelOutline } from "@mdi/js";


export default {
  layout: "admin",
  components: {
    barChart,
    VueApexCharts,
    ApexHorizontalBarChart,
  },
  props: ["pollId", "title"],
  data() {
    return {
      tab: null,
      poll: {},
      answers: [],
      formErrors: [],
      descriptionHtml: "",
      icons: {
        mdiFileExcel, mdiFileExcelBox, mdiMicrosoftExcel, mdiFileExcelBoxOutline, mdiFileExcelOutline
      }
    };
  },
  computed: {
    pageTitle() {
      if (!this.title) {
        return this.poll.title;
      }
      return this.title;
    }
  },
  created() {
    if (this.pollId) {
      this.getPoll(this.pollId);
    }
  },
  methods: {
    tabChange(tab) {
      if (tab == "tab-1") {
        setTimeout(() => {
          this.$forceUpdate(); // Notice we have to use a $ here
        }, 100);
      }
    },
    async getPoll(id) {
      const response = await adminApi.getPoll(id);
      if (response.ok) {
        this.poll = response.data;
        if (!this.title) {
          const { markdownToHtml } = useMarkdown();
          // this.title = this.poll.title;
          this.descriptionHtml = markdownToHtml(this.poll.description);
        }

        this.getAnswers(id);
      }
    },
    async getAnswers(id) {
      const response = await adminApi.getAnswers(id);

      if (response.ok) {
        this.answers = response.data;
      }
    },
    getOptionAnswer(question, answer) {
      const questionAnswer = answer.answers.find(
        (answer) => answer.question === question.id
      );
      if (questionAnswer) {
        const selectedOption = question.question_options.find(
          (o) => o.id == questionAnswer.selected_option
        );
        if (selectedOption) {
          return selectedOption.title;
        }
      }
      return "";
    },
    getTextAnswer(question, answer) {
      const questionAnswer = answer.answers.find(
        (answer) => answer.question === question.id
      );
      if (questionAnswer) {
        return questionAnswer.text_answer;
      }
      return "";
    },
    getChartLabels(question) {
      return question.question_options.map((o) => {
        return o.title;
      });
    },
    getChartSeries(question) {
      return [
        {
          name: this.$t("Vastauksia"),
          data: question.question_options.map((option) => {
            let count = 0;
            this.answers.forEach((answer) => {
              const questionAnswer = answer.answers.find(
                (answer) => answer.question === question.id
              );
              if (
                questionAnswer &&
                questionAnswer.selected_option == option.id
              ) {
                count++;
              }
            });

            return count;
          }),
        },
      ];
    },
    getInsertTime(answer) {
      let m = moment(answer.insert_time);
      return m.format("D.M.Y H:mm");
    },
    excelExport() {
      var wb = utils.book_new();

      var data = [[]];

      if (this.poll.anonymous == false) {
        data[0].push(['Käyttäjä']);
      }

      data[0].push(['Vastausaika']);
      this.poll.poll_questions.forEach(q => {
        data[0].push(q.question);
      });

      let index = 1;
      this.answers.forEach(a => {
        let answerData = [];

        if (this.poll.anonymous == false) {
          answerData.push(a.user);
        }

        answerData.push(this.getInsertTime(a));

        this.poll.poll_questions.forEach(pq => {
          if (pq.question_type == 1) {
            answerData.push(this.getOptionAnswer(pq, a));
          }
          else {
            answerData.push(this.getTextAnswer(pq, a));
          }
        });

        data.push(answerData);
        index++;
      });

      var ws = utils.aoa_to_sheet(data);

      utils.book_append_sheet(wb, ws, "Sheet1");
      writeFileXLSX(wb, `${this.poll.title}.xlsx`);
    }
  },
};
</script>
